import React from "react";

function Divider({ className = "my-2" }) {
	return <div className={`border-t border-muted ${className}`}></div>;
}

export default Divider;
